<template>
  <div class="options">
    <div class="ul dis_f_l">
        <div class="liTitle" v-if="isOpen">{{name}}</div>
        <div class="liTitleActive" v-else>{{name}}</div>
        <div class="liContent dis_f_l dis_f_w" :class="{liContentActive:expertActive}">
            <div class="liZi dis_f_c_c hand" :class="{'classActice':liActice}" @click="all" v-if="isAll">全部</div>
            <div class="liZi dis_f_c_c hand" :class="{classActice:item.liActice == true}" v-for="(item,index) in array" :key="index" @click="activeIndex(item)">{{item.name}}</div>
        </div>
        <div class="dis_f_r_t" style="flex:1">
            <div class="dis_f_l_c hand expert" @click="open()"> 
                <span>展开全部分类</span>
                <i class="el-icon-arrow-right expertTou" :class="{expertActive:expertActive}"></i>
            </div>
        </div>
        
    </div>
  </div>
</template>
<script>
  export default {
    name: "",
    props: {
        // 列表
        list: {
            type: Array,
            default:null
        },
        // 名字
        name:{
            type: String,
            default:""
        },
        // 不显示全部
        isAll:{
            type: Boolean,
            default:true
        },
        // 自动展开前面的名字
        isOpen:{
            type: Boolean,
            default:true
        }
    },
    data() {
      return {
       liActice:false,//全部类似重置
       array:[],//数组
       expertActive:false,
       listArr:[],//存储数组
       listSplice:[],//截取来的数组
      }
    },
    components: {
      
    },
    watch: {},
    computed: {},
    mounted(){
        // 深克隆
        let list = JSON.parse(JSON.stringify(this.list));
        list.forEach(arr => {
            arr.liActice = false;
        });
        this.listArr = JSON.parse(JSON.stringify(list));
        if(this.listArr.length > 9){
            this.listSplice = this.listArr.splice(0,9);
            this.array = this.listSplice;
        }else{
            this.array = this.listArr;
        }
    },
    created() {

    },
    methods: { 
        // 全部
        all(){
            this.array.forEach(arr => {
                arr.liActice = false;
            });
            this.liActice = true;//全部
            this.$emit("listMethods",{array:[]});
        },
        // 选项
        activeIndex(item){
            this.liActice = false;//全部
            item.liActice = !item.liActice;//选中
            let list = [];
            this.array.forEach(arr => {
                if(arr.liActice == true){
                    list.push(arr);
                }
            });
            this.$emit("listMethods",{array:list});
        },
        // 展开
        open(){
            this.expertActive = !this.expertActive;
            if(this.expertActive){
                setTimeout(() => {
                    this.array = [...this.listSplice,...this.listArr];
                }, 300);
            }else{
                this.array = this.listSplice;
            }
        }
    },
  };
</script>
<style lang="scss" scoped>
$colorTitle:#272A31;
.options{
    width: 100%;
    .ul{
        width: 100%;
        .liTitle{
            width: 48px;
            height: 30px;
            line-height: 30px;
            display: inline-block;
            font-size: 15px;
            font-family: PingFang SC;
            font-weight: bold;
            color: $colorTitle;
            margin-right: 20px;
            text-align: justify;
            vertical-align: top;
            &::after {
                display: inline-block;
                width: 100%;
                content: '';
                height: 0;
            }
        }
        .liTitleActive{
            height: 30px;
            line-height: 30px;
            display: inline-block;
            font-size: 15px;
            font-family: PingFang SC;
            font-weight: bold;
            color: $colorTitle;
            margin-right: 20px;
        }
        .liContent{
            width: 940px;
            overflow: hidden;
            min-height: 30px;
            transition: all 0.3s;
            .liZi{
                width: 94px;
                height: 30px;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #45484E;
                border-radius: 4px;
                margin-right: 10px;
                margin-bottom: 4px;
            }
            // .liZi:nth-child(n+10){
            //     margin-bottom: 0!important;
            // }
            .liZi:hover{
                color: var(--themeColor);
            }
            .classActice{
                background-color: var(--themeBg);
                font-weight: bold;
                color: var(--themeColor);
                transition: all 0.2s;
            }
        }
        .liContentActive{
            // min-height: 180px;
            min-height: 120px;
            transition: all 0.3s;
        }
        .expert{
            height: 30px;
            margin-right: 10px;
            margin-bottom: 4px;
            font-size: 14px;
            line-height: 20px;
            .expertTou{
                transform: rotate(0deg);
                transition: all 0.3s;
                font-size: 14px;
                line-height: 20px;
            }
            .expertActive{
                transform: rotate(90deg);
                transition: all 0.3s;
            }
        }
    }
}
</style>
    
